// AudioBus singleton.
// Web Audio's AudioContext must be created/resumed inside a user gesture handler
// — call initAudioBus() from a click/touch listener. getAudioBus() after that
// returns the live instance.

import { AudioBus } from "./AudioBus";

let instance: AudioBus | null = null;

export async function initAudioBus(): Promise<AudioBus> {
  if (!instance) instance = new AudioBus();
  await instance.resume();
  // Shutter SFX is a FE-static asset (/audio/ShutterSfx.mp3) — fire-and-forget;
  // capture works without it if the load is slow or fails.
  void instance.loadShutter("/audio/ShutterSfx.mp3");
  return instance;
}

export function getAudioBus(): AudioBus {
  if (!instance) throw new Error("AudioBus not initialized — call initAudioBus() inside a user gesture");
  return instance;
}

export { AudioBus };
